import type { AuthUser } from '../types/api.types';

/**
 * Pantalla de aterrizaje (ruta relativa al tenant) según los permisos efectivos.
 * Si el rol no puede ver el dashboard cae a una pantalla que sí puede ver
 * (Tareas, luego Campo) en vez de "Acceso denegado".
 */
export function pickLandingPath(
  permissions: ReadonlySet<string> | readonly string[],
  activeRole?: string | null,
): string {
  const has = (p: string) => (permissions instanceof Set ? permissions.has(p) : (permissions as readonly string[]).includes(p));
  if (has('dashboard:read')) return activeRole === 'INVESTOR' ? 'investor/overview' : 'dashboard';
  if (has('tasks:read')) return 'tareas';
  if (has('lotes:read')) return 'campo';
  return 'dashboard';
}

/**
 * Destino por defecto para rutas desconocidas o la raíz.
 * Con sesión: landing del tenant de la sesión (usa el código/slug de URL, nunca el UUID).
 * Sin sesión: login del tenant conocido (store) o /demo/login como último recurso.
 */
export function resolveDefaultRoute(
  token: string | null | undefined,
  user: Pick<AuthUser, 'tenantCode' | 'tenantId' | 'activeRole'> | null | undefined,
  knownTenantCode?: string | null,
): string {
  if (token && user) {
    const slug = user.tenantCode ?? user.tenantId;
    if (slug) return `/${slug}/${user.activeRole === 'INVESTOR' ? 'investor/overview' : 'dashboard'}`;
  }
  return `/${knownTenantCode || 'demo'}/login`;
}
